export default __webpack_public_path__ + "static/media/fa-regular-400.6086b966.ttf";